import {InsurerId} from '../../Config/dataModel';
import {fetchQRCode} from '../Actions/qrCodeAction';

export default (dispatch) => {
    return {
        fetchQRCode: (ref: string, data: InsurerId) => {
            dispatch(fetchQRCode(ref, data));
        }
    };
};



// WEBPACK FOOTER //
// ./src/ReduxRequests/Dispatch/qrCodeDispatch.ts